// Copyright © 2021 Move Closer

import { Component, Vue } from 'vue-property-decorator'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'PlayIcon',
  template: '<span class="play-icon" role="presentation" />'
})
export class PlayIcon extends Vue {}
